module.exports = __webpack_public_path__ + "img/upload-icon.7be3ad34.svg";